export const SUBJECTS = {
  '국어': 'korean',
  '수학': 'math',
  '영어': 'english',
  '사회': 'social',
  '과학': 'science',
  '역사': 'history',
  '도덕': 'ethics',
  '체육': 'pe',
  '음악': 'music',
  '미술': 'art',
  '기술': 'technology',
  '가정': 'home',
  '정보': 'information',
  '중국어': 'chinese',
  '일본어': 'japanese',
  '한문': 'chinese',
  '기타': 'others'
} as const;

export type SubjectType = keyof typeof SUBJECTS;

export const getSubjectId = (subject: SubjectType): string => {
  return SUBJECTS[subject];
};

export const getSubjectName = (subjectId: string): string => {
  const found = Object.entries(SUBJECTS).find(([ko, en]) => en === subjectId);
  return found ? found[0] : subjectId;
}; 